"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_table_1 = __importDefault(require("react-table"));
var react_table_hoc_fixed_columns_1 = __importDefault(require("react-table-hoc-fixed-columns"));
var ui_1 = require("@aperza/ui");
var SellerGroupModelListPagination_1 = __importDefault(require("../sellerGroupModel/SellerGroupModelListPagination"));
var SellerShippingTooltip_1 = __importDefault(require("./SellerShippingTooltip"));
var react_i18next_1 = require("react-i18next");
var react_device_detect_1 = require("react-device-detect");
var ReactTableFixedColumns = react_table_hoc_fixed_columns_1.default(react_table_1.default);
var SellerShippingPrice = /** @class */ (function (_super) {
    __extends(SellerShippingPrice, _super);
    // CONSTRUCTOR
    function SellerShippingPrice(props) {
        return _super.call(this, props) || this;
    }
    SellerShippingPrice.prototype.createColumns = function (tableConfig) {
        var columns = [
            {
                Header: react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.heading" }),
                id: 'prefecture',
                accessor: function (d) { return d; },
                Cell: function (props) { return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ui_1.WebMediaQuery, { desktopOnly: true },
                        react_1.default.createElement("div", null,
                            props.value.locationName,
                            react_1.default.createElement(SellerShippingTooltip_1.default, { shippingInfo: props.value, shippingType: "weight" }),
                            react_1.default.createElement(SellerShippingTooltip_1.default, { shippingInfo: props.value, shippingType: "quantity" }))))); },
                width: 250,
                fixed: 'left',
            },
        ];
        // Assigning Columns
        var baseShippingFeesHeadings = [];
        tableConfig.sortedBaseShippingFeesColumns.forEach(function (col, index) {
            baseShippingFeesHeadings.push({
                Header: col,
                id: 'baseShipping_' + index,
                accessor: function (d) {
                    return d.baseShippingFees[col] != 0 ? (d.baseShippingFees[col]) : (react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.free" }));
                },
                // width: 150,
            });
        });
        columns.push({
            accessor: function (d) { return d.baseShippingFees; },
            columns: baseShippingFeesHeadings,
        });
        return columns;
    };
    SellerShippingPrice.prototype.render = function () {
        var tableConfig = this.props.tableConfig;
        if (tableConfig && tableConfig.data && tableConfig.data.length > 0) {
            // Rendering begin
            console.log('this.data', tableConfig.data);
            if (!react_device_detect_1.isMobile) {
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(ReactTableFixedColumns, { data: tableConfig.data, columns: this.createColumns(tableConfig), sortable: false, resizable: false, footer: false, className: "shipping-fee-table table-vh-hover -highlight", PaginationComponent: SellerGroupModelListPagination_1.default, showPageSizeOption: false, showPageJump: false, defaultPageSize: 10 })));
            }
            else {
                return tableConfig.data.map(function (prefecture, index) {
                    var tableData = [];
                    tableConfig.sortedBaseShippingFeesColumns.forEach(function (col, index) {
                        tableData.push(react_1.default.createElement("tr", { key: 'mtrow_' + index },
                            react_1.default.createElement("td", null, col),
                            react_1.default.createElement("td", null, prefecture.baseShippingFees[col] ? (prefecture.baseShippingFees[col]) : (react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.free" })))));
                    });
                    return (react_1.default.createElement("div", { className: "shipping-fee-group-mobile", key: 'pref' + index },
                        react_1.default.createElement("h2", null, prefecture.locationName),
                        react_1.default.createElement("table", null,
                            react_1.default.createElement("thead", null,
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", null,
                                        react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.heading" }),
                                            react_1.default.createElement(SellerShippingTooltip_1.default, { shippingInfo: prefecture, shippingType: "weight" }))),
                                    react_1.default.createElement("th", null,
                                        react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.shippingFee" }),
                                            react_1.default.createElement(SellerShippingTooltip_1.default, { shippingInfo: prefecture, shippingType: "quantity" }))))),
                            react_1.default.createElement("tbody", null, tableData))));
                });
            }
        }
        else {
            console.log('No Shipping Price Data Found');
            return null;
        }
    };
    return SellerShippingPrice;
}(react_1.default.Component));
exports.default = react_i18next_1.withTranslation()(SellerShippingPrice);
